import React from "react";
import { Button } from "@mui/material";

const DownloadCarPricesButton = () => {
 const handleDownload = async () => {
  try {
   const response = await fetch(
    "https://app-api.carexpert.org.in/api/price/download-car-prices",
   );

   if (!response.ok) throw new Error("Failed to download file");

   const blob = await response.blob();
   const url = window.URL.createObjectURL(blob);

   const link = document.createElement("a");
   link.href = url;
   link.download = "car_prices.xlsx";
   document.body.appendChild(link);
   link.click();
   link.remove();
   window.URL.revokeObjectURL(url);
  } catch (err) {
   console.error("Download failed:", err);
   alert("Download failed.");
  }
 };

 return (
  <Button variant="contained" color="primary" onClick={handleDownload}>
   📥 Download Car Prices Excel
  </Button>
 );
};

export default DownloadCarPricesButton;
